export default __webpack_public_path__ + "static/fiveStar-a73f98255194ce46274bd7ff27f2d6c3.png";